import { LuArrowDown, LuArrowUp, LuX } from "react-icons/lu";
import { Loading } from "./Loading"

export default function DashboardTable({ tableData, isLoading }) {

    const { headLabels, list, data, actions, handleSortOptions, handleClearSort, params = {sort_by: '', sort_order: ''} } = tableData

    const tHeadStyle = {
        padding: '10px 20px',
        fontSize: '12px',
        fontWeight: '500',
        color: '#595959',
        textWrap: 'nowrap'
    }

    return (
        <table className="w-full relative text-[14px] text-[#595959]">
            {isLoading && (
                <div className="w-full h-full min-h-[600px] bg-white/50 backdrop-blur-sm absolute top-0 left-0 z-10">
                    <Loading />
                </div>
            )}
            <thead>
                <tr className="bg-[#F9FAFB] border-b border-[#eee]">
                    {headLabels.map(label => {
                        const isSortable = !!label.sort_value;
                        const isActiveSort = isSortable && params.sort_by === label.sort_value;
                        return (
                            <td
                                key={label.id || label.name || label}
                                style={tHeadStyle}
                                className={`${isActiveSort ? '!bg-primary !text-white !font-semibold' : ''} ${isSortable ? 'cursor-pointer hover:bg-gray-100' : ''}`}
                                onClick={isSortable ? () => handleSortOptions(label.sort_value) : undefined}
                            >
                                <div className="flex items-center justify-between">
                                    <span>{label.name || label}</span>
                                    {isActiveSort ? params.sort_order === 'desc' ? <span><LuArrowDown /></span> : <span><LuArrowUp /></span> : <></>}
                                </div>
                            </td>
                        );
                    })}
                    {actions && <td style={tHeadStyle} className="text-center">Actions</td>}
                </tr>
            </thead>
            {data && (
                <tbody className="[&>*:nth-child(even)]:bg-[#F9FAFB]">
                    {list}
                </tbody>
            )}
        </table>
    )
}